import React, { useContext } from "react";

import { ProjectContext, Sds, LinkedApplicationContext, ConfigContext } from "@swegon/sds-core";
import OutdatedNotice from "../components/OutdatedNotice";
import ReleaseNotice from "../components/ReleaseNotice";
import CopyProjectId from "../components/CopyProjectId";
import { getAhuBaseUrl } from "../ahu/lib";

export const SdsWrapper = ({ children }) => {
    const { project } = useContext(ProjectContext);
    const { querystring } = useContext(LinkedApplicationContext);
    const { config } = useContext(ConfigContext);

    const ahuBaseUrl = getAhuBaseUrl(window.location.pathname, config);
    const ahuUrl = new URL(querystring, ahuBaseUrl);

    // Only show these menu options when there's a project selected cause then we can
    // be certain we're in AHU since the old routing will only work when we're in there
    const items = project
        ? [
            {
                icon: "print",
                name: "Print",
                tooltip: "navigation.print",
                action: () => {
                    window.location.hash = "#print|pw";
                }
            },
            {
                icon: "climate",
                name: "Climate",
                tooltip: "navigation.climateSettings",
                action: () => {
                    window.location.hash = "#climateSettings|pw";
                }
            },
            {
                icon: "settings",
                name: "Settings",
                tooltip: "navigation.settings",
                action: () => {
                    window.location.hash = "#settings|pw";
                }
            }
        ]
        : [];

    return (
        <Sds
            print={null}
            settings={null}
            name={project ? project.Name : ""}
            version={`v${config.app_version}`}
            goHome={() => {
                window.location = ahuUrl;
            }}
            items={items}
            titles={["AHU 1 in SDS 2"]}
            headerInfo={
                <>
                    <CopyProjectId />
                    <OutdatedNotice />
                    <ReleaseNotice />
                </>
            }
            useSdsPrint={false}
            useSdsSettings={false}
        >
            {children}
        </Sds>
    );
};
export default SdsWrapper;
